import { render, staticRenderFns } from "./PublishingContractsSubCataloguesEditPanelTopSlot.vue?vue&type=template&id=71e45c61"
import script from "./PublishingContractsSubCataloguesEditPanelTopSlot.vue?vue&type=script&lang=js"
export * from "./PublishingContractsSubCataloguesEditPanelTopSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports